import { IPatientInfo } from 'apis/admin/type';
import { SurveyFormProps } from 'components/MuiDialog/SurveyForm';
import {
  initialECardex,
  initialTakingOver,
  initialOutHospitalSurvey,
  initialHospitalizationSurvey,
  initialMedicationSurvey,
  initialRadiology,
  initialPathology,
  initialBedScore,
  initialFall,
  initialPediatric_fall,
  initialGCS,
  initialPediatric_GCS,
  initialFourScore,
  initialSafety,
  initialNeeds,
  initialClinicalObservation,
  initialGlucose,
  initialNRS,
  initialFLACC,
  initialCNPS,
  initialFFI,
  initialKOOS,
  initialLEFS,
  initialSTarTBack,
  initialNDI,
  initialMentalNursing,
  initialBDI,
  initialBAI,
  initialMMSE,
  initialOperation,
  initialAnesthesia,
  initialTransfusion,
  initialDialysis,
  initialEmergency,
  initialChildbirth,
  initialHomeCare,
  initialDietNutrition,
  initialFallPrevention,
  initialTransfusionAgree,
  initialColonoscopy,
  initialTransfusionAgreement,
  initialNonSalary,
  initialAdmissionCheckList,
  initialDNR,
  initialCoreNursingSkillVideo,
  initialIntakeOutput,
  initialClinicalObservationICU,
  initialIntubation,
  initialCPR,
  initialHospitalConfirm,
  initialCRRT,
  initialIntubationAgree,
  initialCentralVenous,
  initialSuppressor,
  initialSBAR,
  initialSBAR2,
  initialSBAR3,
} from './initialStates';

export enum MENU {
  E_CARDEX = '電子病歷',
  SBAR1 = 'SBAR 1',
  SBAR2 = 'SBAR 2',
  SBAR3 = 'SBAR 3',
  TAKING_OVER = '護理交班',
  HOSPITALIZATION = '護理交班',
  OUT_HOSPITAL = '出院記錄',
  PRESCRIPTION = '處方記錄',
  NURSE = '護理歷史',
  MEDICATION = '用藥記錄',
  RADIOLOGY = '放射攝影紀錄',
  PATHOLOGY = '臨床病理學',
  CLINICAL_OBSERVATION = '生命體徵記錄',
  CLINICAL_OBSERVATION_ICU = '臨床觀察\n(重症監護室)',
  IORECORD = 'I/O 輸液輸入',
  GLUCOSE = '血糖記錄表',
  BEDSORES = '布雷登壓瘡風險評估量表',
  NEEDS = '需求評估',
  FALL = 'Morse Fall Scale',
  FALLSCALE = '亨普蒂跌倒評估量表',
  GCS = 'GCS',
  Pediatric_GCS = '兒童版GCS',
  FourScore = 'FOUR量表',
  SAFETY = '患者安全報告',
  PAIN = '疼痛評估',
  NRS = 'NRS',
  FLACC = 'FLACC疼痛評估量表',
  CNPS = 'CNPS',
  FFI = '足功能指數',
  KOOS = '膝關節損傷與骨關節炎結果評估量表',
  LEFS = '下肢功能評估量表',
  NDI = '頸部殘疾指數',
  STarT_BacknScreening = 'STarT 背部筛查',
  MENTAL_NURSING = '心理健康記錄',
  BDI = 'BDI',
  BAI = 'BAI',
  MMSE = 'MMSE',
  COGNITIVE_FUNCTION = '인지기능검사',
  OPERATION = '手術',
  ANESTHESIA = '麻醉记录',
  TRANSFUSION = '输血',
  INTUBATION = '插管',
  CPR = '心肺復甦',
  DIALYSIS = '透析',
  EMERGENCY = '急诊',
  CHILDBIRTH = '分娩',
  HOME_CARE = '居家护理记',
  DIET_NUTRITION = '飲食與營養',
  AGREEMENT = 'Agreement',
  PATIENTSGUIDE = '患者指南',
  PATIENTCONSENTFORM = '一般病患同意書',
  TRANSFUSION_AGREE = '输血 / 輸血',
  CONSCIOUS = '清醒鎮靜',
  DNR = '拒絕維生醫療',
  ADMISSION = '住院協議',
  ADMISSION_CHECKLIST = '入院檢查清單',
  FALL_PREVENTION = '跌倒預防教育',
  CRRT_AGREEMENT = '持續性腎臟替代治療',
  CENTRALVENOUS = '中心靜脈導管置放',
  INTUBATIONAGREEMENT = '氣管插管',
  SUPPRESSOR = '身體約束同意書',
  ADMISSIONGUIDE = '入院指南',
  DRUGCALCULATOR = '藥物計算器',
  CORE_NURSING_SKILL_VIDEO = '影片上傳',
  CORE_NURSING_SKILL_VIDEO_EXEMPLE = 'Screen Settings',
  PATIENT_LABEL_PRINTING = '病人标签打印',
}

export enum RECORD_TYPE {
  NANDA = '0',
  SOAPIE = '1',
  FOCUS_DAR = '2',
  NARRATIVE_RECORD = '3',
  REMARKS = '4',
}

export interface SurveyDialogProps<T>
  extends Omit<SurveyFormProps, 'children'> {
  user_id: number;
  nurseName: string;
  patientInfo: IPatientInfo;
  disabled?: boolean;
  defaultValues: T;
}

export type TECardexDefaultValues = typeof initialECardex;
export type TSBARDefaultValues = typeof initialSBAR;
export type TSBAR2DefaultValues = typeof initialSBAR2;
export type TSBAR3DefaultValues = typeof initialSBAR3;
export type TTakingOverDefaultValues = typeof initialTakingOver;
export type THospitalizationDefaultValues = typeof initialHospitalizationSurvey;
export type TOutHospitalDefaultValues = typeof initialOutHospitalSurvey;
export type TMedicationDefaultValues = typeof initialMedicationSurvey;
export type TRadiologyDefaultValues = typeof initialRadiology;
export type TPathologyDefaultValues = typeof initialPathology;
export type TClinicalObservationDefaultValues =
  typeof initialClinicalObservation;
export type TClinicalObservationICUDefaultValues =
  typeof initialClinicalObservationICU;
export type TGlucoseDefaultValues = typeof initialGlucose;
export type TIntakeOutputDefaultValues = typeof initialIntakeOutput;
export type TBedScoreDefaultValues = typeof initialBedScore;
export type TNeedsDefaultValues = typeof initialNeeds;
export type TFallDefaultValues = typeof initialFall;
export type TPediatric_fallDefaultValues = typeof initialPediatric_fall;
export type TGCSDefaultValues = typeof initialGCS;
export type TPediaTric_GCSDefaultValues = typeof initialPediatric_GCS;
export type TFourScoreDefaultValues = typeof initialFourScore;
export type TSafetyDefaultValues = typeof initialSafety;
export type TNRSDefaultValues = typeof initialNRS;
export type TFLACCDefaultValues = typeof initialFLACC;
export type TCNPSDefaultValues = typeof initialCNPS;
export type TFFIDefaultValues = typeof initialFFI;
export type TKOOSDefaultValues = typeof initialKOOS;
export type TLEFSDefaultValues = typeof initialLEFS;
export type TNDIDefaultValues = typeof initialNDI;
export type TSTarTBackScreeningDefaultValues = typeof initialSTarTBack;
export type TMentalNursingDefaultValues = typeof initialMentalNursing;
export type TBDIDefaultValues = typeof initialBDI;
export type TBAIDefaultValues = typeof initialBAI;
export type TMMSEDefaultValues = typeof initialMMSE;
export type TOperationDefaultValues = typeof initialOperation;
export type TAnesthesiaDefaultValues = typeof initialAnesthesia;
// Patient Guide => 수혈동의서
export type TTransfusionDefaultValues = typeof initialTransfusion;
// Patient Consent Form => 대장내시경으로
export type TColonoscopyDefaultValues = typeof initialColonoscopy;
export type TTransfusionAgreeDefaultValues = typeof initialTransfusionAgree;
// Conscious Sedation => 비급여동의서로
export type TNonSalaryDefaultValues = typeof initialNonSalary;
export type TDNRDefaultValues = typeof initialDNR;
// Admission Agreement=> 입원안내확인서
export type THospitalConfirmDefaultValues = typeof initialHospitalConfirm;
export type TAdmissionCheckListDefaultValues = typeof initialAdmissionCheckList;
export type TFallPreventionDefaultValues = typeof initialFallPrevention;
export type TCRRTDefaultValues = typeof initialCRRT;
export type TCentralVenousDefaultValues = typeof initialCentralVenous;
export type TIntubationAgreeDefaultValues = typeof initialIntubationAgree;
export type TSuppressorDefaultValues = typeof initialSuppressor;

export type TIntubationDefaultValues = typeof initialIntubation;
export type TCPRDefaultValues = typeof initialCPR;
export type TDialysisDefaultValues = typeof initialDialysis;
export type TEmergencyDefaultValues = typeof initialEmergency;
export type TChildbirthDefaultValues = typeof initialChildbirth;
export type THomeCareDefaultValues = typeof initialHomeCare;
export type TDietNutritionDefaultValues = typeof initialDietNutrition;
export type TTransfusionAgreementDefaultValues =
  typeof initialTransfusionAgreement;
export type TCoreNursingSkillVideoDefaultValues =
  typeof initialCoreNursingSkillVideo;
